import React from 'react';

interface FacebookIconProps {
  className?: string;
}

function FacebookIcon({ className }: FacebookIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" className={className}>
      <path
        fill="currentColor"
        d="M8.26.003L6.202 0C3.892 0 2.4 1.532 2.4 3.902v1.8H.333a.323.323 0 00-.323.323V8.63c0 .179.145.324.323.324h2.068v6.577c0 .179.144.323.323.323H5.42a.323.323 0 00.323-.323V8.955h2.418a.323.323 0 00.323-.324V6.025a.324.324 0 00-.323-.324H5.744V4.176c0-.733.175-1.105 1.13-1.105h1.385a.323.323 0 00.323-.324V.327A.323.323 0 008.26.003z"
      ></path>
    </svg>
  );
}

export default FacebookIcon;
